var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 5,
    viewBox: "0 0 4 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2914e-07 2.5C0.000572338 2.39365 0.0263945 2.28875 0.0755939 2.19292C0.124793 2.09708 0.196135 2.01272 0.284444 1.94594L2.55111 0.192116C2.68757 0.0896333 2.852 0.0251425 3.02566 0.00599251C3.19932 -0.0131575 3.37523 0.0138036 3.53333 0.0838036C3.67074 0.140576 3.78782 0.233222 3.87057 0.350676C3.95332 0.468131 3.99825 0.60543 4 0.746175L4 4.25382C3.99825 4.39457 3.95332 4.53187 3.87057 4.64932C3.78782 4.76678 3.67074 4.85942 3.53333 4.9162C3.37523 4.9862 3.19932 5.01316 3.02566 4.99401C2.852 4.97486 2.68757 4.91037 2.55111 4.80788L0.284444 3.05406C0.196135 2.98728 0.124793 2.90291 0.0755938 2.80708C0.0263945 2.71125 0.000572329 2.60635 1.2914e-07 2.5Z",
    fill: "#868F96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.bc421881cb5c5744de0c65e257112e73.svg";
export { ForwardRef as ReactComponent };